import { useState, useRef, useEffect } from "react";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import Modal from "../../Modal/Modal";
import RateForm from "../../Modal/ModalContent/RateForm/RateForm";
import { useAppContext } from "../../../../../../Components/AppProvider";
export default function CompletedOrderComponent({ order, formatToMMDDYYYY }) {
  const { setOrderListUpdate, setCountListUpdateById } = useAppContext();
  const [isExpanded, setIsExpanded] = useState(false);
  const [height, setHeight] = useState("0px");
  const [transactions, setTransactions] = useState({});
  const contentRef = useRef(null);
  const [isModalOpen, setModalOpen] = useState(null);
  const handelPaymentModal = (cmd) => {
    //console.log(cmd);
    setModalOpen(cmd); // open modal
  };
  // ✅ Expand/collapse animation
  useEffect(() => {
    if (isExpanded) {
      setHeight(`${contentRef.current.scrollHeight}px`);
    } else {
      setHeight("0px");
    }
  }, [isExpanded, transactions]);

  // ✅ Fetch transaction history when expanded
  useEffect(() => {
    const loadTransactionHistory = async () => {
      if (isExpanded && !transactions[order.COI_ID]) {
        try {
          const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/orders/get-transaction-history/${order.COI_ID}`,
          );
          const data = await res.json();
          setTransactions((prev) => ({
            ...prev,
            [order.COI_ID]: data.transactions,
          }));
        } catch (error) {
          console.error("Failed to load transaction history:", error);
        }
      }
    };

    loadTransactionHistory();
  }, [isExpanded, order.COI_ID, transactions]);
  const handleRate = async (rateVal, review, selectedFiles) => {
    try {
      const formData = new FormData();
      formData.append("PD_ID", order.PD_ID);
      formData.append("COI_ID", order.COI_ID);
      formData.append("CP_ID", order.CP_ID);
      formData.append("rateVal", rateVal);
      formData.append("review", review);

      selectedFiles.forEach((file) => {
        formData.append("mediaFiles", file);
      });

      const res = await fetch(
        `https://littlekidinside.shop/api/rate/insert-rate`,
        {
          method: "POST",
          body: formData,
          credentials: "include",
        },
      );

      // read response as text first
      const text = await res.text();
      let data;

      try {
        data = JSON.parse(text); // try parsing JSON
      } catch {
        console.warn("⚠️ Non-JSON response:", text);
        data = { message: text }; // fallback
      }

      if (!res.ok) {
        throw new Error(data.error || data.message || "Upload failed");
      }

      alert("✅ Rating submitted successfully!");
      setOrderListUpdate(true);
      setCountListUpdateById((p) => !p);
    } catch (err) {
      console.error("❌ Rating error:", err);
      alert(`❌ ${err.message}`);
    }
  };

  return (
    <>
      {" "}
      <div key={order.COI_ID} className="dp-item-wrapper">
        {/* Header Row
        <div className="checkbox-wrapper">
          <input
            type="checkbox"
            checked={selectedOrders.includes(order.COI_ID)}
            onChange={() => handleSelectOrder(order.COI_ID)}
          />
        </div> */}
        <div className="grid-image-wrapper">
          <img
            src={`${process.env.REACT_APP_BASE_URL}Assets/Products/${order.PD_ID}/${order.PD_ProductPicPath[0]}`}
            alt={order.PD_Name}
          />
        </div>
        <div className="grid-order-details-wrapper">
          <div className="ord-prod-name">
            <span className="name">{order.PD_Name}</span>
            <span className="qty">x{order.COI_Quantity}</span>
          </div>
          <span>DATE ORDERED : {formatToMMDDYYYY(order.COI_Created_At)}</span>
          <span>ORDER NUMBER : {order.COI_Number}</span>
        </div>
        <div className="grid-order-status-wrapper">
          <span className="ord-prod-status" style={{ color: `#007d0c` }}>
            {order.COI_IsRated === 0 ? "COMPLETED" : "ORDER RATED"}
          </span>

          <span>AMOUNT PAID : PHP {order.COI_TotalAmount}</span>
        </div>
        <div className="grid-message-wrapper">
          {order.COI_IsRated === 0 ? (
            <span style={{ color: `#007d0c` }}>
              We would have your feedback on this item!
            </span>
          ) : (
            <span style={{ color: `#007d0c` }}>Thank you for feedback!</span>
          )}
          <span
            className="m-link"
            style={{ cursor: "pointer" }}
            onClick={() => setIsExpanded((prev) => !prev)}
          >
            View history {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
          </span>
        </div>

        <div className="grid-payment-wrapper">
          <div className="buttons-wrapper">
            {order.COI_IsRated === 0 ? (
              <button
                className="pay-btn"
                onClick={() => handelPaymentModal("rate")}
              >
                RATE
              </button>
            ) : (
              ""
            )}
          </div>
        </div>

        {/* ✅ Expandable Section */}
        <div
          ref={contentRef}
          className="items-list"
          style={{
            maxHeight: height,
            overflow: "hidden",
            transition: "max-height 0.4s ease, opacity 0.3s ease",
            opacity: isExpanded ? 1 : 0,
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
            marginTop: "10px",
            padding: isExpanded ? "10px 0px" : "0 0px",
          }}
        >
          {/* 👇 Transaction History UI */}
          <div className="history-content">
            <h4>Transaction History</h4>

            {transactions[order.COI_ID] ? (
              transactions[order.COI_ID].length > 0 ? (
                transactions[order.COI_ID].map((tx, idx) => (
                  <div key={idx} style={{ marginBottom: "10px" }}>
                    <p>
                      <strong>{formatToMMDDYYYY(tx.DatePurchase)}</strong> –{" "}
                      {tx.PaymentType} via {tx.PaymentMethod} – PHP{" "}
                      {tx.PaymentAmount}
                      <br />
                      Status: {tx.Status}
                      <br />
                      <a
                        href={`${process.env.REACT_APP_BASE_URL}Assets/purchase_order/${tx.TransactionID}/${tx.Receipt}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "blue",
                          cursor: "pointer",
                        }}
                      >
                        <span>VIEW RECEIPT</span>
                      </a>
                    </p>

                    <ul>
                      {tx.OrderItems.map((item, i) => {
                        const isHighlighted =
                          item.ProductID === order.PD_ID ||
                          item.ProductName === order.PD_Name;

                        return (
                          <li
                            key={i}
                            style={{
                              backgroundColor: isHighlighted
                                ? "gray"
                                : "transparent",
                              borderRadius: "5px",
                              padding: "4px 8px",
                              fontWeight: isHighlighted ? "600" : "normal",
                              transition: "background-color 0.3s ease",
                            }}
                          >
                            {item.ProductName} × {item.Quantity} @ PHP{" "}
                            {item.UnitPrice} = PHP {item.TotalAmount} —
                            Deposited: PHP {item.Deposited} Balance: PHP{" "}
                            {item.Balance}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ))
              ) : (
                <p>No transactions available.</p>
              )
            ) : (
              <p>Loading transaction history...</p>
            )}
          </div>
        </div>
      </div>{" "}
      <Modal
        isModalOpen={isModalOpen}
        onClose={() => {
          setModalOpen(null);
        }}
      >
        <RateForm onClose={() => setModalOpen(null)} handleRate={handleRate} />
      </Modal>
    </>
  );
}
